const Calendar = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 17" {...props}>
    <g fill="#1A4A7A" clipPath="url(#calendar_svg__a)">
      <path d="M5.739 8.878a.87.87 0 1 1-1.74 0 .87.87 0 0 1 1.74 0M8.87 8.878a.87.87 0 1 1-1.74 0 .87.87 0 0 1 1.74 0M12 8.878a.87.87 0 1 1-1.74 0 .87.87 0 0 1 1.74 0" />
      <path d="M13.333 2.081h-.667V.748h-1.333v1.333H4.666V.748H3.333v1.333h-.667c-.733 0-1.333.6-1.333 1.334V14.08c0 .734.6 1.334 1.333 1.334h10.667c.733 0 1.333-.6 1.333-1.334V3.415c0-.734-.6-1.334-1.333-1.334m0 12H2.666V6.748h10.667zm0-8.666H2.666v-2h10.667z" />
    </g>
    <defs>
      <clipPath id="calendar_svg__a">
        <path fill="#fff" d="M0 .082h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default Calendar;
